export const validateFieldsStartChar = (object) => {
    for (const [key, value] of Object.entries(object)) {
        if (typeof value === 'string' && (value.startsWith('=') || value.startsWith('+') || value.startsWith('-') || value.startsWith('@'))) {
            return { isValid: false, key, value };
        }
    }
    return { isValid: true };
};